import {Outlet, useOutletContext, useParams} from "react-router-dom";
import React, {useState} from "react";
import {GetSignInTemplate} from "../stages/SignIn.Component";
import {GetErrorTemplate} from "../stages/Error.Component";
import {GetForwardTemplate} from "../stages/Forward.Component";
import {useQueryParam} from "../utilities/UseQueryParams";

export default function Stage() {
    let params = useParams();
    let token = useQueryParam("a");

    const [company] = useOutletContext();
    const [application, setApplication] = useState({});

    if (params.application != null && application.name == null && application.address == null) {
        setApplication(getApplication(params));
    }

    return (
        <div>
            {GetStageTemplate(params, company, application, token)}
            <Outlet context={[application, setApplication]}/>
        </div>
    )
}

const GetStageTemplate = (params, company, application, token) => {
    switch (params.stage.toLowerCase()) {
        case "signin":
            return GetSignInTemplate(company, application);
        case "forward":
            return GetForwardTemplate(company, application, token);
        default:
            return GetErrorTemplate(company, application);
    }
}


const getApplication = (params) => {
    let address;
    let name;
    switch (params.application.toString().toLowerCase()) {
        case 'wda':
            name = "WDA";
            address = process.env.REACT_APP_WDA_REDIRECT_ADDRESS;
            break;
        case 'install':
            name = "INSTALL";
            address = process.env.REACT_APP_INSTALL_REDIRECT_ADDRESS;
            break;
        case 'k9':
        default:
            name = "K9";
            address = process.env.REACT_APP_K9_REDIRECT_ADDRESS;
            break;
    }
    return {
        name: name,
        address: address
    }
}
